import React from 'react'
import PropTypes from 'prop-types'

import CartSection from 'components/cart/Section/Section'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import TotalPrice from './TotalPrice/TotalPrice'
import Credits from './Credits/Credits'
import BillRow from './BillRow/BillRow'

import s from './Bill.scss'


const PaymentBill = (props) => {
  const {
    isFetching,
    items,
    total,
    credits,
    creditValue,
    creditBalance,
    useCredits,
    resubscribeMessage,
  } = props

  return (
    <div className={s.bill}>
      {
        items.map((item, index) => (
          <BillRow key={index} {...item} isFetching={isFetching} />
        ))
      }
      {/* TODO it's better to split this component on 3: bill, balance, resubscribe mess, total price */}
      {
        Boolean(credits) && (
          <Credits {...{ isFetching, total, creditValue, creditBalance, useCredits }} />
        )
      }
      <CartSection>
        {
          Boolean(resubscribeMessage) && (
            <Box mb="16">
              <Text message={resubscribeMessage} uppercase />
            </Box>
          )
        }
        <TotalPrice {...{ isFetching, total }} />
      </CartSection>
    </div>
  )
}

PaymentBill.propTypes = {
  isFetching: PropTypes.bool,
  items: PropTypes.array,
  total: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
}

PaymentBill.defaultProps = {
  isFetching: false,
  items: [],
}


export default PaymentBill
